import AdministrationMenuService from '../../../../../administrationMenu/AdministrationMenuService';
import types from './mutation-types';
import translate from '../../../../../common/localization/translate';
import VcomProvider from '../../../../../VcomProvider';

// eslint-disable-next-line fp/no-let
let cachedSystemId;

export default {
  async load({ commit }, systemId) {
    const adminIdChanged = systemId !== cachedSystemId;
    if (!adminIdChanged) {
      return;
    }
    const [menu, title, image, hasValidLicense] = await Promise.all([
      AdministrationMenuService.loadMenu(systemId),
      systemId ? AdministrationMenuService.getSystemName(systemId) : translate('portal.NAVI_ADMINISTRATION'),
      systemId ? AdministrationMenuService.loadSystemImage(systemId) : null,
      systemId ? AdministrationMenuService.hasValidLicense(systemId) : true,
    ]);
    cachedSystemId = systemId;
    commit(types.UPDATE_MENU, menu);
    commit(types.UPDATE_TITLE, title);
    commit(types.UPDATE_IMAGE, image);
    commit(types.UPDATE_HAS_VALID_LICENSE, hasValidLicense);
  },

  resetToPreviousAdministrationId() {
    VcomProvider.adminSystemId = cachedSystemId;
  },

  destroyMenu({ commit }) {
    cachedSystemId = undefined;
    commit(types.DESTROY_MENU);
    commit(types.DESTROY_TITLE);
    commit(types.DESTROY_IMAGE);
    commit(types.DESTROY_HAS_VALID_LICENSE);
  },
};
